import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  CarouselProps,
  Carousel as ResponsiveCarousel,
} from "react-responsive-carousel";
import "./Carousel.css";

interface CarouselPropsExtended extends CarouselProps {
  carouselItems?: React.JSX.Element[];
  height?: number;
  itemStyle?: React.CSSProperties; // Adding style prop for inline styles
}

const Carousel = (props: Partial<CarouselPropsExtended>) => {
  return (
    <ResponsiveCarousel {...props}>
      {Array.isArray(props.carouselItems)
        ? props.carouselItems.map((item, index) => (
            <div key={`carousel-item-${index}`} className="carousel-item">
              {React.cloneElement(item, { style: props.itemStyle })}
            </div>
          ))
        : []}
    </ResponsiveCarousel>
  );
};

export default Carousel;